export const actionTypes = {
  HISTORY_COMMIT: 'HISTORY_COMMIT',
  HISTORY_UNDO: 'HISTORY_UNDO',
  HISTORY_REDO: 'HISTORY_REDO',
  HISTORY_FLUSH: 'HISTORY_FLUSH',
  HISTORY_TRANSACTION_BEGIN: 'HISTORY_TRANSACTION_BEGIN',
  HISTORY_TRANSACTION_END: 'HISTORY_TRANSACTION_END',
  HISTORY_CLEAR: 'HISTORY_CLEAR',
  HISTORY_SET_AUDIO_CHECKPOINT: 'HISTORY_SET_AUDIO_CHECKPOINT',
  HISTORY_APPLY_PATCHES: 'HISTORY_APPLY_PATCHES',
  HISTORY_PURGE_REFERENCE: 'HISTORY_PURGE_REFERENCE',
  HISTORY_REFRESH_HEAD_SNAPSHOTS: 'HISTORY_REFRESH_HEAD_SNAPSHOTS',
};

const commit = (scope, entry) => ({
  type: actionTypes.HISTORY_COMMIT,
  payload: { scope, entry },
});

const undo = (scope) => ({
  type: actionTypes.HISTORY_UNDO,
  payload: { scope },
});

const redo = (scope) => ({
  type: actionTypes.HISTORY_REDO,
  payload: { scope },
});

const flush = (scope) => ({
  type: actionTypes.HISTORY_FLUSH,
  payload: { scope },
});

const beginTransaction = (scope, label) => ({
  type: actionTypes.HISTORY_TRANSACTION_BEGIN,
  payload: { scope, label },
});

const endTransaction = (scope) => ({
  type: actionTypes.HISTORY_TRANSACTION_END,
  payload: { scope },
});

const clear = (scope) => ({
  type: actionTypes.HISTORY_CLEAR,
  payload: { scope },
});

const setAudioCheckpoint = (scope, audioCheckpoint, options = {}) => ({
  type: actionTypes.HISTORY_SET_AUDIO_CHECKPOINT,
  payload: { scope, audioCheckpoint, options },
});

const applyPatchesAction = (scope, patches, options = {}) => ({
  type: actionTypes.HISTORY_APPLY_PATCHES,
  payload: { scope, patches, options },
});

const purgeReference = (scope, slice) => ({
  type: actionTypes.HISTORY_PURGE_REFERENCE,
  payload: { scope, slice },
});

const refreshHeadSnapshots = (scope, snapshots) => ({
  type: actionTypes.HISTORY_REFRESH_HEAD_SNAPSHOTS,
  payload: { scope, snapshots },
});

export {
  commit,
  undo,
  redo,
  flush,
  beginTransaction,
  endTransaction,
  clear,
  setAudioCheckpoint,
  applyPatchesAction as applyPatches,
  purgeReference,
  refreshHeadSnapshots,
};
